module.exports = __webpack_public_path__ + "img/component_production_1200x800.4892caca.svg";